import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { useEffect } from 'react'
import { Box, Button, Typography, Error } from 'shared/ui'
import { DragAndDropSection } from 'shared/ui/DragAndDrop'
import { ReviewAccountItem } from 'pages/reviews/ui/ReviewAccounts/ui/ReviewAccountItem'
import { type ReviewAccountsStore } from '../store/reviewAccountsStore'
import styles from './styles.module.scss'

type IReviewAccountsStoreProps = {
  store: ReviewAccountsStore
  error: string
  removeError: (key: string) => void
}

export const ReviewAccounts = observer(
  ({ store, error, removeError }: IReviewAccountsStoreProps) => {
    const {
      isAddDisabled,
      showAddAccountsModal,
      accounts,
      onEdit,
      onRemove,
      reorderAccounts,
      isErrorExistInAccounts,
    } = store
    const items = Array.from(accounts)

    useEffect(() => {
      if (items.length > 0) removeError('accounts')
    }, [items.length])

    return (
      <div className={classNames(styles.wrap, { [styles.error]: error || isErrorExistInAccounts })}>
        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
          <Typography variant={'body-rg-medium'} ariaLabel={'myReviewAccounts'}>
            My review accounts
          </Typography>
          <Button
            text={'Add'}
            icon={'add'}
            size={'small'}
            contained={'primary'}
            disabled={isAddDisabled}
            tooltipProps={{
              visibility: isAddDisabled ? 'visible' : 'hidden',
              label: '10 account limit reached',
              placement: 'top',
            }}
            onClick={showAddAccountsModal}
          />
        </Box>
        {items.length > 0 && (
          <Box paddingTop={'16px'}>
            <DragAndDropSection
              droppableId='review-accounts'
              items={items}
              onReorder={reorderAccounts}
              renderItem={(account, provided, snapshot) => (
                <ReviewAccountItem
                  item={account}
                  onEdit={onEdit}
                  onRemove={onRemove}
                  dragHandleProps={provided.dragHandleProps}
                  isDragging={snapshot.isDragging}
                />
              )}
            />
          </Box>
        )}
        {!items.length && error && (
          <Box marginTop={'-3px'}>
            <Error type={'text'} error={error} />
          </Box>
        )}
      </div>
    )
  }
)
